import * as Types from "./typesActions";
import initialState from "./store";

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.SEARCH:
      return {
        ...state,
        gridNiveis: { ...state.gridNiveis, search: state.gridNiveis.search += 1 },
        gridUsuariosVinculados: { ...state.gridUsuariosVinculados, search: state.gridUsuariosVinculados.search += 1 }
      };
    case Types.WAS_SELECTED:
      return {
        ...state,
        gridNiveis: { ...state.gridNiveis, arrayOfSelected: action.payload },
        gridUsuariosVinculados: { ...state.gridUsuariosVinculados, arrayOfSelected: action.payload }
      };
    case Types.WAS_DOUBLE_CLICK:
      return {
        ...state,
        gridNiveis: { ...state.gridNiveis, wasDoubleClick: action.payload },
        gridUsuarios: { ...state.gridUsuarios, wasDoubleClick: action.payload }
      };
    case Types.CHANGED_DESCRIPTION:
      return {
        ...state,
        inputDescription: { ...state.inputDescription, tags: action.payload }
      };
    case Types.CHANGED_VALUE:
      return {
        ...state,
        inputDescription: { ...state.inputDescription, value: action.payload }
      };
    case Types.CHANGED_SELECTED_RESOURCES:
      return {
        ...state,
        selectTreeModalResources: { ...state.selectTreeModalResources, selected: action.payload }
      };
    case Types.LOAD_RESOURCES:
      return {
        ...state,
        selectTreeModalResources: { ...state.selectTreeModalResources, options: action.payload }
      };
    case Types.CHANGED_SELECTED_APPLICATIONS:
      return {
        ...state,
        selectApplications: { ...state.selectApplications, selected: action.payload },
        selectTreeModalResources: { ...state.selectTreeModalResources, selected: [], options: [] }
      };
    case Types.LOAD_APPLICATIONS:
      return {
        ...state,
        selectApplications: { ...state.selectApplications, options: action.payload }
      };
    case Types.CHANGED_PANEL_BODY:
      return {
        ...state,
        filtersPanelApplications: { ...state.filtersPanelApplications, body: action.payload }
      };
    case Types.SEARCH_PANEL_FILTERS:
      return {
        ...state,
        filtersPanelApplications: { ...state.filtersPanelApplications, search: action.payload },
      };
    default:
      return state;
  }
}